(ns app.front.view.group.reporting.filters
  (:require [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.filter-common :as filter-common]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.subs :as gas]
            [app.query.filter-util :as filter-util]
            [app.reporting.model :as reporting-model]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx ::fetch-saved-filters
  (fn [{:keys [db]} [_ group-id]]
    {:comm/command {:command          :report/saved-filters
                    :data             {:group-id group-id}
                    :on-success       [::fetch-saved-filters.success]
                    :finally-dispatch [::fetch-saved-filters.done]}
     :db           (assoc-in db [::filters :loading?] true)}))


(rf/reg-event-fx ::fetch-saved-filters.success
  (fn [_ [_ status response]]
    {:dispatch [::entities/merge-entity-db status (:reporting-filters response)]}))


(rf/reg-event-db ::fetch-saved-filters.done
  #(assoc-in % [::filters :loading?] false))


(rf/reg-sub ::filters
  #(-> % ::filters))


(rf/reg-sub ::filters-loading?
  :<- [::filters]
  #(-> % :loading?))


(rf/reg-sub ::saving-filter?
  :<- [::filters]
  #(-> % ::saving-filter?))


(rf/reg-event-fx ::save-filter
  (fn [{:keys [db]} [_ filter-name filter-data]]
    {:comm/command {:command          :user/upsert-reporting-filter
                    :data             (assoc filter-data :filter/name filter-name)
                    :on-success       [::save-filter.success]
                    :finally-dispatch [::save-filter.done]}
     :db           (assoc-in db [::filters :saving-filter?] true)}))


(rf/reg-event-fx ::save-filter.success
  (fn [_ [_ status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [:notifications/add :toast :success :success :reporting/save-preset-success]]}))


(rf/reg-event-db ::save-filter.done
  #(p/dissoc-in % [::filters :saving-filter?]))


(rf/reg-event-fx ::delete-filter
  (fn [_ [_ filter-id]]
    {:comm/command {:command    :user/remove-reporting-filter
                    :data       {:id filter-id}
                    :on-success [::delete-filter.success]}}))


(rf/reg-event-fx
  ::delete-filter.success
  (fn [_ [_ status response]]
    {:dispatch-n [[::entities/apply-changes status response]
                  [:notifications/add :toast :success :success :reporting/delete-preset-success]]}))


(rf/reg-sub ::reporting-filters
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] [_ filter-type]]
    (->> (entities/find-entities ctx {:entity/type :entity.type/reporting-filter})
         (filter #(and (reporting-model/matching-group-id? group-id %)
                       (= filter-type (:filter/type %))))
         (sort-by :filter/name))))

(defn remove-pseudo-settings [filter-settings]
  (dissoc filter-settings :field-tab-idx))

(defn filters-equal? [f1 f2]
  (= (remove-pseudo-settings f1)
     (remove-pseudo-settings f2)))

(rf/reg-sub ::selected-saved-filter
  (fn [[_ filter-settings-sub filter-type] _]
    [(rf/subscribe [::reporting-filters filter-type])
     (rf/subscribe [filter-settings-sub])])
  (fn [[reporting-filters filter-settings]]
    (-> reporting-filters
        (p/find-first #(filters-equal? (-> %
                                           filter-util/filter-entity->search-values-map)
                                       filter-settings)))))


(defn filters [tr {:keys [filter-type
                          filter-settings-sub
                          default-filters-sub
                          conditions-sub
                          select-saved-filter-evt
                          initialize-settings-evt
                          initialize-settings-params]}]
  (let [filters-loading?  (<sub [::filters-loading?])
        reporting-filters (<sub [::reporting-filters filter-type])
        selected-filter   (<sub [::selected-saved-filter filter-settings-sub filter-type])
        default-filters?  (<sub [default-filters-sub])
        conditions        (<sub [conditions-sub])]
    [:div.flex.w-full.items-center.relative
     [:div
      (if filters-loading?
        (cc/select-skeleton {:hide-label true})
        [ui-select/select
         {:id           "saved-workspace-searches"
          :class-name   "full-width-select"
          :allow-empty? false
          :select-text  (tr [:reporting/saved-presets])
          :values       reporting-filters
          :on-change    #(>evt [select-saved-filter-evt %])
          :value        selected-filter
          :val->str     :filter/name}])]
     [:div.absolute.right-1.flex
      (when-not default-filters?
        [:<>
         (cc/button {:kind     :ghost
                     :size     :small
                     :on-click #(>evt [initialize-settings-evt initialize-settings-params])}
                    (tr [:reporting/clear-settings]))
         (when-not selected-filter
           [:div.flex-shrink-0.mr-4
            [filter-common/save-filter-controls tr {:saving-filter?     (<sub [::saving-filter?])
                                                    :filters            reporting-filters
                                                    :save-evt           ::save-filter
                                                    :save-evt-opts      {:filter/type       filter-type
                                                                         :filter/conditions conditions}
                                                    :save-tr-key        :reporting/save-settings
                                                    :loading-tr-key     :reporting/saving-preset
                                                    :filter-name-tr-key :reporting/preset-name}]])])
      [:div.flex.justify-end
       (when selected-filter
         [ui/modal-confirmation-button
          {:id                  "delete-preset-button"
           :tr                  tr
           :modal-title         (tr [:dashboard-search/delete-filter-title])
           :trigger-button-opts {:kind          :ghost
                                 :size          :small
                                 :icon-position :left
                                 :class-name    (str "text-ui-red-100 hover:border-ui-red-100 hover:text-ui-white "
                                                     "hover:bg-ui-red-100 focus:text-ui-white focus:bg-ui-red-100 "
                                                     "focus:outline-none")}
           :trigger-button-text (tr [:reporting/delete-preset])
           :on-yes-click        #(>evt [::delete-filter (:db/id selected-filter)])}
          (tr [:reporting/delete-preset-modal]
              [(:filter/name selected-filter)])])]]]))
